

import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class IBStaticBadge extends Vue {

	@Prop([ String, Number ])
	readonly text!: string | number

	get empty(): boolean {
		return this.text === 0;
	}

}

